const PERMISSIONS = {
  SUPERUSER: 0,
  ADMIN: 1,
  MANAGER: 2,
  OFFICE: 3,
  DEFAULT: 4,
};

const STATUS = {
  UNREAD: 0,
  OPEN: 1,
  REVIEWED: 13,
  RESOLVED: 2,
  CRITICAL: 3,
  GIVENTOCC: 14,
  GIVENTODR: 4,
  RECEIVEDBACK: 5,
  LEFTVOICEMAIL: 6,
  URGENTCARE: 7,
  APPT2WEEKS: 8,
  APPT4WEEKS: 9,
  CHECKTASKS: 10,
  SCAN: 11,
  FOLLOWUP: 12,
};

const UNASSIGNED = "UNASSIGNED";

const ALERTLEVEL = {
  NONE: 0,
  INACTIVE: 1,
  WARNING: 2,
  CRITICAL: 3,
  EMERGENCY: 4,
};

const SORTINGTYPES = {
  DATE: 0,
  ALERTLEVEL: 1,
  JOURNEYID: 2,
  TCODES: 3,
};

const TCODEVIEW = "TCODE";
const ENCOUNTERVIEW = "ENCOUNTER";

export {
  PERMISSIONS,
  STATUS,
  ALERTLEVEL,
  SORTINGTYPES,
  UNASSIGNED,
  TCODEVIEW,
  ENCOUNTERVIEW,
};
